module.exports = __webpack_public_path__ + "static/img/3.d8bb408.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/eng/3.png
// module id = 1U3q
// module chunks = 0